/**
 * @alias task.getPropertyDescriptor
 * @param {Object} object
 * @param {string} property
 * @return {?Object}
 */
export default (object, property) =>
{
    let proto = object;
    let descriptor;

    // eslint-disable-next-line no-cond-assign
    while (proto && !(descriptor = Object.getOwnPropertyDescriptor(proto, property)))
    {
        proto = Object.getPrototypeOf(proto);
    }

    return descriptor || null;
};
